import { render, staticRenderFns } from "./ChatbotWindow.vue?vue&type=template&id=07071395&scoped=true"
import script from "./ChatbotWindow.vue?vue&type=script&lang=js"
export * from "./ChatbotWindow.vue?vue&type=script&lang=js"
import style0 from "./ChatbotWindow.vue?vue&type=style&index=0&id=07071395&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07071395",
  null
  
)

export default component.exports